import { withProps } from 'recompose';
import Item from './Item';
import { formatAmount } from '../../utils/format';

const AmountItem = withProps(({ value, showCents = false }) => ({ value: formatAmount(value, showCents) }))(Item);

export default AmountItem;
